import * as React from 'react'

function SvgCheckCheckedIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="m32.293 8.293 1.414 1.414L28 15.414l-3.707-3.707 1.414-1.414L28 12.586l4.293-4.293Z"
        fill="#2EC40B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
        fill="#2EC40B"
      />
      <path
        d="M17.4 11H20c0 .687.077 1.357.223 2H17.4c-1.153 0-1.898.002-2.464.048-.544.044-.745.12-.844.17a2 2 0 0 0-.874.874c-.05.099-.126.3-.17.844-.046.566-.048 1.31-.048 2.464v5.2c0 1.153.002 1.898.048 2.464.044.544.12.745.17.844a2 2 0 0 0 .874.874c.099.05.3.126.844.17.566.046 1.31.048 2.464.048h5.2c1.153 0 1.898-.002 2.464-.048.544-.044.745-.12.844-.17a2 2 0 0 0 .874-.874c.05-.099.126-.3.17-.844.046-.566.048-1.31.048-2.464v-2.357l.387-.387A9.055 9.055 0 0 0 29 20v2.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C25.96 29 24.84 29 22.6 29h-5.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C11 25.96 11 24.84 11 22.6v-5.2c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C14.04 11 15.16 11 17.4 11Z"
        fill="#000"
      />
      <path
        d="m20.354 21.232 3.124-3.124c.54.42 1.13.78 1.759 1.07l-4.883 4.883a.5.5 0 0 1-.707 0l-5-5a.5.5 0 0 1 0-.707l.707-.707a.5.5 0 0 1 .707 0l3.585 3.585a.5.5 0 0 0 .708 0Z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgCheckCheckedIcon
